import { hydrateRenderedComponents } from "@streeteasy/render-service/client";

import ListingProgressMenu from "../src/features/my-activity/components/ListingProgressMenuContainer";
import NoOpenHousesModal from "../src/features/my-activity/components/NoOpenHousesModal";
import SaveButton from "../src/features/my-activity/components/SaveButton";
import TourLikes from "../src/features/my-activity/components/TourLikes";
import TourRating from "../src/features/my-activity/components/TourRating";
import MyActivityOpenHousesApp from "../src/features/open-house-registration-my-activity";
import exportComponentsToRails from "../src/shared/utilities/exportComponentsToRails";

exportComponentsToRails("myActivity", {
  ListingProgressMenu,
  NoOpenHousesModal,
  SaveButton,
  TourLikes,
  TourRating
});

hydrateRenderedComponents("myActivity", {
  myActivityOpenHouses: MyActivityOpenHousesApp
});
